
export class ScopedClass {

    constructor(scopePrefix='scope') {
        const methodsList = Object.getOwnPropertyNames(this.__proto__);

        for (const method of methodsList) {
            if (method.indexOf(scopePrefix) != -1) {
                this[method]();
            }
        }
    }
}
